import React, {useEffect, useState} from 'react'
import useFeedbacksHook from './useFeedbacksHook'
import Button from '@material-ui/core/Button'
import List from './List'
import RatingsSelector from './RatingsSelector'
import user_api from 'utils/api/users'

const Feedbacks = () => {
  let {getFeedbacks, feedbacks, setRatingToDisplay} = useFeedbacksHook()
  const [isLoading, setIsLoading] = useState(false);
  const handleDownload = async () => {
      setIsLoading(true);
      try {
        await user_api.download_feedbacks();
      } catch (err) {
        console.error('Download failed', err);
      } finally {
        setIsLoading(false);
      }
    };
  return (
    <>
      <RatingsSelector
        onSelect={(rating) => {
          setRatingToDisplay(rating)
        }}
      />
      <Button type="button" onClick={handleDownload} disabled={isLoading}>
        {isLoading ? 'Downloading...' : 'Download Responses'}
      </Button>
      <List feedbacks={feedbacks.data} onLoadMore={feedbacks.status !== 'end' ? getFeedbacks : null} />
    </>
  )
}

export default Feedbacks
